
<app-main-layout></app-main-layout>
<ngx-spinner type="timer" size="medium">
    <p style="color: white" > Loading... </p>
</ngx-spinner>